var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment-wrapper';
import { MortageRateCategory, MortgageRateSubCategory, MortgageRate } from '../classes/mortgage-rate';
import { PaymentsFrequency } from '../classes/enums';
import { map } from 'rxjs/operators';
// temporary static rates until XML is available
var StaticRates = [{
        name: 'Mortgage Rates',
        rates: [
            {
                term: '1 year',
                name: '1 Year Fixed Rate',
                rate: '2.79%'
            },
            {
                term: '2 year',
                name: '2 Year Fixed Rate',
                rate: '2.89%'
            },
            {
                term: '3 year',
                name: '3 Year Fixed Rate',
                rate: '3.49%'
            },
            {
                term: '5 year',
                name: '5 Year Fixed Rate',
                rate: '4.79%'
            },
            {
                term: '7 year',
                name: '7 Year Fixed Rate',
                rate: '5.60%'
            },
            {
                term: '3 year',
                name: '3 Year Variable Rate Flex',
                rate: '2.45%'
            },
            {
                term: '5 year',
                name: '5 Year Variable Rate Flex',
                rate: '2.45%'
            },
        ]
    }];
var MortgageService = /** @class */ (function () {
    function MortgageService(appConfig, http) {
        this.appConfig = appConfig;
        this.http = http;
        // Set up static rates
        var rate = new MortageRateCategory();
        rate.rateCategory = 'Mortgage Rates';
        rate.subCategories = StaticRates;
        this._rates = [rate];
    }
    MortgageService.prototype.getRates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._rates)
                            return [2 /*return*/, new Promise(function (resolve) { return resolve(_this._rates); })];
                        return [4 /*yield*/, this.http.get(environment.baseServerUrl + this.appConfig.urls.mortgage.base, { withCredentials: false })
                                .pipe(map(function (res) {
                                _this._rates = res.result.map(function (r) { return _this._convertToRateCategory(r); });
                                return _this._rates;
                            }))
                                .toPromise()];
                    case 1: 
                    // TODO: Errors
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MortgageService.prototype._convertToRate = function (tmpRate) {
        var rate = new MortgageRate();
        rate.term = tmpRate['@term'];
        rate.name = tmpRate.Name['#cdata-section'];
        rate.rate = tmpRate.Value['#cdata-section'];
        return rate;
    };
    // TODO: is there a way we can convert everything to array
    MortgageService.prototype._convertToRateSubCategory = function (tmpRateSub) {
        var _this = this;
        var subCat = new MortgageRateSubCategory();
        subCat.name = tmpRateSub['@ID'];
        // In some cases where there is only one rate, its just a single object, not an array
        if (tmpRateSub.Rate.length)
            subCat.rates = tmpRateSub.Rate.filter(function (tmpR) { return tmpR.Value['#cdata-section'] !== '&nbsp;'; }).map(function (tmpR) { return _this._convertToRate(tmpR); });
        else
            subCat.rates = [this._convertToRate(tmpRateSub.Rate)];
        return subCat;
    };
    MortgageService.prototype._convertToRateCategory = function (tmpCat) {
        var _this = this;
        var rc = new MortageRateCategory();
        var tmpRateCategory = tmpCat.RateCategory;
        rc.rateCategory = tmpRateCategory['@ID'];
        rc.subCategories = tmpRateCategory.RateSubCategory.map(function (tmpS) { return _this._convertToRateSubCategory(tmpS); });
        return rc;
    };
    MortgageService.prototype._getPaymentsPerMonth = function (frequency) {
        switch (frequency) {
            // TODO: CONSTANTS WUT
            case PaymentsFrequency.BiWeekly:
                return 12 / 26;
            case PaymentsFrequency.RapidBiWeekly:
                return 1 / 2;
            case PaymentsFrequency.Weekly:
                return 12 / 52;
            case PaymentsFrequency.RapidWeekly:
                return 1 / 4;
            default:
                return 1;
        }
    };
    MortgageService.prototype._getEffectiveAnnualInterestRate = function (decimalInterestRate) {
        var compoundFrequencyPerYear = 2;
        return Math.pow((1 + decimalInterestRate / compoundFrequencyPerYear), compoundFrequencyPerYear) - 1;
    };
    MortgageService.prototype._getMonthlyInterestRate = function (annualRate) {
        return Math.pow((1 + annualRate), (1 / 12)) - 1;
    };
    /**
     * All payment frequencies are based on the monthly rate.
     * @param mortgageAmount the principal amount of the loan (we don't account for down payments so this ends up being the listing price)
     * @param decimalInterestRate the interest rate provided by the bank
     * @param amortizationPeriod the number of years setup to payoff the loan
     * @returns a monthly payment value
     */
    MortgageService.prototype._getMonthlyMortgagePaymentRate = function (mortgageAmount, decimalInterestRate, amortizationPeriod) {
        var interestPerMonth = this._getMonthlyInterestRate(this._getEffectiveAnnualInterestRate(decimalInterestRate));
        var totalMonths = amortizationPeriod * 12;
        return (mortgageAmount * interestPerMonth) / (1 - Math.pow((1 + interestPerMonth), (-1 * totalMonths)));
    };
    ;
    MortgageService.prototype._getCost = function (mortgageAmount, paymentsPerMonth, decimalInterestRate, amortizationPeriod) {
        return this._getMonthlyMortgagePaymentRate(mortgageAmount, decimalInterestRate, amortizationPeriod) * paymentsPerMonth;
    };
    ;
    MortgageService.prototype.calculateMortgagePayment = function (mortgageAmount, decimalInterestRate, paymentsPerMonthEnumeration, amortizationPeriod) {
        var paymentsPerMonth = this._getPaymentsPerMonth(paymentsPerMonthEnumeration);
        var cost = this._getCost(mortgageAmount, paymentsPerMonth, decimalInterestRate, amortizationPeriod);
        return isNaN(cost) ? 0 : cost;
    };
    return MortgageService;
}());
export { MortgageService };
